var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v(" New app ")]),_c('v-card-text',[_c('AppNew')],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('AppList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }